import SourceToken from '@admin/tokens/source'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Type extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          instructions: 't(At the beginning of each month, we will payout your affiliate commision to the 3rd party payment platform of your choice)',
          fields: [
            { 
              label: 't(Send my payouts to)', 
              type: 'segment',
              fields: [
                {
                  name: 'service',
                  type: 'radiogroup',
                  options: [
                    { source_name: 'paypal', name: 'Paypal' },
                    { source_name: 'venmo', name: 'Venmo' }
                  ],
                  format: (source) => <SourceToken source={ source } />,
                  valueKey: 'source_name',
                  defaultValue: 'paypal',
                  required: true
                },
                {
                  label: 't(Paypal Email)',
                  name: 'service_id',
                  type: 'emailfield',
                  show: config.service === 'paypal',
                  required: true
                },
                {
                  label: 't(Venmo Username)',
                  name: 'service_id',
                  type: 'textfield',
                  show: config.service === 'venmo',
                  required: true
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(affilaite) {
    this.props.onNext(affilaite)
  }

}

export default Type
